export default "__VITE_ASSET__94e7cba1__"